import { api } from './axios';
import { PartnerEntity } from '../interfaces/partners';

export const getPartners = async (eventId: string) => {
  const partnersQuery = `query getPartners { 
    partnerList (where: { eventId: { eq: "${eventId}"}}) { 
      nodes {
        url
        eventId 
        imageId 
        id 
      } 
    } 
  }`;

  const partners = api
    .post('', {
      query: partnersQuery,
      operationName: 'getPartners'
    })
    .then((res) => res.data.data.partnerList.nodes as PartnerEntity[])
    .catch((res) => res.data);

  return partners;
};
